import {Alert, Attributes, Flag, Flags, Table, TableRow} from 'platform/components';
import {Box, Heading, Show, Text, VStack} from 'platform/foundation';
import {useDateTimeFormatter} from 'platform/locale';

import {useGetMyMultiFactorAuthenticationSettingsQuery} from '@dms/api/base';
import i18n from '@dms/i18n';

import {parseDate} from 'shared/web';

export function PairedInfo() {
  const {data: userMfaSettings} = useGetMyMultiFactorAuthenticationSettingsQuery();

  const formatDateTime = useDateTimeFormatter();

  return (
    <Box maxWidth={200}>
      <VStack spacing={5}>
        <Alert variant="success" title={i18n.t('page.myProfile.labels.multiFactorAuthSuccess')} />

        <Show when={userMfaSettings}>
          {(userMfaSettings) => (
            <VStack spacing={4}>
              <VStack spacing={2}>
                <Heading size={4}>
                  {i18n.t('page.myProfile.labels.multiFactorAuthActiveLoginTypes')}
                </Heading>

                <Flags
                  flags={userMfaSettings.activeLoginTypes.map((type) => ({
                    label: i18n.t(`page.myProfile.dashboard.labels.${type}`),
                  }))}
                />
              </VStack>

              <Attributes
                size="third"
                rows={[
                  {
                    label: i18n.t('page.myProfile.labels.multiFactorAuthActivatedAt'),
                    value: userMfaSettings.activatedAt
                      ? formatDateTime('dateTimeShort', parseDate(userMfaSettings.activatedAt))
                      : null,
                  },
                  {
                    label: i18n.t('page.myProfile.labels.multiFactorAuthActivateUntil'),
                    value: formatDateTime(
                      'dateTimeShort',
                      parseDate(userMfaSettings.activateUntil)
                    ),
                  },
                  {
                    label: i18n.t('page.myProfile.labels.multiFactorAuthSetUpAt'),
                    value: formatDateTime('dateTimeShort', parseDate(userMfaSettings.setUpAt)),
                  },
                ]}
              />

              <VStack spacing={2}>
                <Heading size={4}>{i18n.t('page.myProfile.labels.multiFactorAuthHistory')}</Heading>

                <Show when={userMfaSettings.history.length > 0}>
                  <Table
                    tableLayout="fixed"
                    variant="stripped"
                    columns={[
                      {
                        element: (
                          <Text align="left" alternative size="small">
                            {i18n.t('page.myProfile.labels.multiFactorAuthHistoryOperation')}
                          </Text>
                        ),
                      },
                      {
                        element: (
                          <Text align="left" alternative size="small">
                            {i18n.t('page.myProfile.labels.multiFactorAuthHistoryType')}
                          </Text>
                        ),
                      },
                      {
                        element: (
                          <Text align="left" alternative size="small">
                            {i18n.t('page.myProfile.labels.multiFactorAuthHistoryTime')}
                          </Text>
                        ),
                      },
                    ]}
                  >
                    {userMfaSettings.history.map((historyItem, index) => (
                      // eslint-disable-next-line react/no-array-index-key -- Pre-existing violation
                      <TableRow key={`${historyItem.time}-${index}`}>
                        <Box paddingVertical={2}>
                          <Flag
                            size="small"
                            colorScheme={historyItem.operation === 'activate' ? 'green' : 'red'}
                            label={i18n.t(
                              `page.myProfile.labels.multiFactorAuthOperation.${historyItem.operation}`
                            )}
                          />
                        </Box>
                        <Box paddingVertical={2}>
                          <Text size="xSmall" color="secondary">
                            {historyItem.type.toUpperCase()}
                          </Text>
                        </Box>
                        <Box paddingVertical={2}>
                          <Text size="xSmall" color="secondary">
                            {formatDateTime('dateTimeShort', parseDate(historyItem.time))}
                          </Text>
                        </Box>
                      </TableRow>
                    ))}
                  </Table>
                </Show>
              </VStack>
            </VStack>
          )}
        </Show>
      </VStack>
    </Box>
  );
}
